<div class="notifications mat-elevation-z8">
  <div class="notifications__header">
    Notifications
  </div>
  <div class="notifications__content">
    <div class="notify" fxLayout="column" *ngFor="let notification of notifications">
      <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="15">
          <mat-icon class="material-icons-outlined"
                    [ngClass]="{ green: notification.notificationTypeID === 3,
                                 warn: notification.notificationTypeID === 2,
                                 red: notification.notificationTypeID === 1}">
            {{ notification.iconCode }}
          </mat-icon>
        </div>
        <div fxFlex="70" class="notify__title">
          <b>{{ notification.notificationSubject }}</b>
        </div>
        <div fxFlex="15" fxLayoutAlign="end center" class="notify__close">
          <button class="dismiss" mat-icon-button
                  [disabled]="loading"
                  (click)="dismissNotification(notification)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div class="notify__desc" fxLayout="row" fxLayoutAlign="start center">
        {{ notification.notificationDescription }}
        <a class="click-here" *ngIf="notification.notificationLink" (click)="redirectNotification(notification)">Click here</a>
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" class="notify__time">
        {{ parseDateFormat(notification.createDate) }}
      </div>
    </div>
  </div>
</div>
